import React from "react";

/**
 * Hero Section Component for Documentation Page
 */
const DocHero = ({ darkMode = false }) => {
  const theme = darkMode
    ? {
        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
        text: "#e2e8f0",
      }
    : {
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        text: "#ffffff",
      };

  return (
    <div
      style={{
        background: theme.background,
        padding: "80px 20px",
        paddingTop: "120px",
        textAlign: "center",
        color: theme.text,
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <h1
          style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)",
            fontWeight: "700",
            marginBottom: "24px",
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          Complete Documentation
        </h1>
        <p
          style={{
            fontSize: "1.3rem",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto",
            lineHeight: "1.6",
          }}
        >
          Everything you need to know about FilingStack Accounting Software
        </p>

        {/* Tutorial CTA */}
        <div
          style={{
            marginTop: "40px",
            padding: "24px",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "16px",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <h3
            style={{
              fontSize: "1.4rem",
              marginBottom: "16px",
              fontWeight: "600",
            }}
          >
            🎯 Start with our Interactive Tutorial
          </h3>
          <p style={{ marginBottom: "20px", opacity: "0.9" }}>
            Take our quick and easy tutorial to get started with FilingStack
          </p>
          <a
            href="/Tutorial"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-block",
              backgroundColor: "#3b82f6",
              color: "white",
              padding: "14px 32px",
              borderRadius: "12px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "1.1rem",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
            }}
          >
            Start Tutorial →
          </a>
          <p style={{ fontSize: "0.9rem", marginTop: "12px", opacity: "0.8" }}>
            (Login required to track progress and receive completion
            certificate)
          </p>
        </div>
      </div>
    </div>
  );
};

export default DocHero;
